export default {
	setQuiz(state, quiz) {
		state.quiz = quiz;
	}
};